module.exports = "<p>exam-duration works!</p>\n"